import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import StateObserver from 'src/StateObserver';
import { openNativeAppStorePage } from '../native.util';

import { AssetGroup } from '@play-co/timestep-core';

const ui = uiConfig.buruburu.invite.confirm;
export default class popupUpdateApp extends PopupBasic {
  constructor(opts: { superview: View; close: VoidFunction }) {
    super({
      superview: opts.superview,
      close: () => opts.close(),
      ...ui.popup,
      height: 300,
      tracking: {
        feature: Feature.NATIVE._,
        $subFeature: Feature.NATIVE.UPDATE_APP_POPUP,
      },
    });

    this.message.updateOpts({
      ...ui.message,
      width: 531,
      height: 72,
      x: 20,
    });

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...ui.okButton,
        centerOnOrigin: true,
        x: this.box.style.width / 2,
        y: 220,
        localeText: () => i18n('native.update.cta'),
        onClick: async () => {
          sounds.sfx.play('ok');

          openNativeAppStorePage({
            tracking: {
              origin: 'launch',
              feature: Feature.NATIVE._,
              subFeature: Feature.NATIVE.UPDATE_APP_POPUP,
              timestamp: StateObserver.now(),
            },
          });
        },
        tracking: {
          feature: Feature.NATIVE.UPDATE_APP_POPUP,
          $subFeature: Feature.NATIVE.UPDATE_APP_POPUP_CTA,
        },
      }),
    );
  }

  protected getAssetsGroup() {
    return new AssetGroup([]);
  }

  public init(opts: { hardUpdate: boolean }) {
    super.init({
      title: i18n('native.update.title'),
      message: i18n('native.update.body'),
    });

    if (opts.hardUpdate) {
      this.buttonClose.removeFromSuperview();
    }
  }
}
